import { IconButton, Dialog, DialogContent } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

type AddNewCardModalProps = {
	open: boolean;
	onClose: () => void;
};

function AddNewCardModal({ open, onClose }: AddNewCardModalProps) {
	return (
		<Dialog
			className="ddDailogWrrapper"
			open={open}
			onClose={onClose}
			maxWidth="xs"
			fullWidth
			sx={{
				'& .MuiDialog-paper': {
					borderRadius: '10px',
					position: 'relative'
				},
				'& .popupCloseIcon': {
					position: 'absolute',
					top: '10px',
					right: '10px'
				}
			}}
		>
			<IconButton
				className="popupCloseIcon"
				onClick={onClose}
			>
				<Close />
			</IconButton>
			<div className="popupBody">
				<DialogContent className="popupContent">
					<Elements stripe={stripePromise}>
						<CheckoutForm setStripeDialogOpen={onClose} />
					</Elements>
				</DialogContent>
			</div>
		</Dialog>
	);
}

export default AddNewCardModal;
